module.exports = __webpack_public_path__ + "img/chat-phone.7ba320f0.png";